import {Brick, registerBrick} from 'olympe';

/**
 * Create a new map from an existing Map
 */
export default class CopyAMap extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Map} map
     * @param {function(Map)} setMap
     */
    update($, [map], [setMap]) {
        setMap(new Map(map));
    }
}

registerBrick('018e765d852f7a109081', CopyAMap);
